import React from 'react';
import { Link } from 'react-router-dom';
import ProductCard from '../common/ProductCard';

/**
 * CategoryProductSection - Product section for a specific category
 * Follows React Rules: Pure component, idempotent
 * 
 * @param {string} title - Section title
 * @param {Array} subCategories - Array of subcategory links
 * @param {Array} products - Array of products to display
 * @param {Function} onAddToCart - Callback for add to cart
 * @param {Function} onAddToWishlist - Callback for wishlist
 * @param {Function} onQuickView - Callback for quick view
 * @param {string} className - Additional CSS classes
 */
const CategoryProductSection = ({
  title,
  subCategories = [],
  products = [],
  onAddToCart,
  onAddToWishlist,
  onQuickView,
  className = ''
}) => {
  if (!products || products.length === 0) {
    return null;
  }

  return (
    <section className={`product-area li-laptop-product ${className}`}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="li-section-title">
              <h2>
                <span>{title}</span>
              </h2>
              {subCategories.length > 0 && (
                <ul className="li-sub-category-list">
                  {subCategories.map((subCat, index) => (
                    <li key={index} className={index === 0 ? 'active' : ''}>
                      <Link to={subCat.link || '/store/shop'}>{subCat.name}</Link>
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="row">
              <div className="product-active owl-carousel" data-react-carousel="true">
                {products.map((product) => (
                  <div key={product.id} className="col-lg-12">
                    <ProductCard
                      product={product}
                      onAddToCart={onAddToCart}
                      onAddToWishlist={onAddToWishlist}
                      onQuickView={onQuickView}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CategoryProductSection;

